// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://refrigerator-management-system-server-dev.yssdev.gr/api/',
  // socketUrl: 'https://refrigerator-management-system-server-dev.yssdev.gr'
  // apiUrl: 'http://localhost:3255/api/',
  // socketUrl: 'http://localhost:3255'
  apiUrl: 'https://crm-app.krikri.gr/api/',
  socketUrl: 'https://crm-app.krikri.gr'
  // apiUrl: 'https://crm-app-test.krikri.gr/api/',
  // socketUrl: 'https://crm-app-test.krikri.gr'
  // apiUrl: 'http://192.168.1.70:3255/api/',
  // socketUrl: 'http://192.168.1.70:3255'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
